/**
 * Sticky header — compact mode.
 *
 * Adds `is-scrolled` class to .site-header when the user scrolls down past
 * ENTER, removes it only after scrolling back up past EXIT. CSS handles the
 * visual compaction (hides marquee + utility/social bars, shrinks logo).
 *
 * Why hysteresis (two thresholds instead of one)?
 *   .site-header is `position: sticky` (in document flow). Compacting collapses
 *   ~78px of bars (utility 40px + marquee ~38px) at the very top of the page.
 *   The browser's scroll anchoring keeps the visible content stable by reducing
 *   window.scrollY by that same ~78px. With a single threshold that drop pushes
 *   scrollY back below it → class removed → bars reappear → scrollY grows again
 *   → class re-added… an infinite flicker loop right around the trigger point.
 *
 *   A dead-band wider than the collapse height (ENTER − EXIT > ~78px) guarantees
 *   the post-toggle scrollY shift can never re-cross the opposite threshold, so
 *   the header settles in one state instead of oscillating.
 */

const ENTER = 140; // compact once scrolled down past this (px)
const EXIT  = 30;   // expand again only after scrolling back above this (px)

const initStickyHeader = () => {
	const header = document.querySelector('.site-header');
	if (!header) return;

	let compact = header.classList.contains('is-scrolled');

	const update = () => {
		const y = window.scrollY;

		if (!compact && y > ENTER) {
			compact = true;
			header.classList.add('is-scrolled');
		} else if (compact && y < EXIT) {
			compact = false;
			header.classList.remove('is-scrolled');
		}
	};

	window.addEventListener('scroll', update, { passive: true });
	// Перше читання scrollY — у кадрі анімації: одразу після парсингу воно змушувало браузер
	// рахувати розкладку синхронно (forced reflow ~70 мс на слабкому мобільному).
	requestAnimationFrame(update);
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initStickyHeader);
} else {
	initStickyHeader();
}
